import logo01 from "@/assets/img/portfolio/logo_01.png";
import logo02 from "@/assets/img/portfolio/logo_02.png";
import logo03 from "@/assets/img/portfolio/logo_03.png";
import logo04 from "@/assets/img/portfolio/logo_04.png";
import logo05 from "@/assets/img/portfolio/logo_05.png";
import logo06 from "@/assets/img/portfolio/logo_06.png";
import logo07 from "@/assets/img/portfolio/logo_07.png";
import logo08 from "@/assets/img/portfolio/logo_08.png";
import logo09 from "@/assets/img/portfolio/logo_09.png";
import logo10 from "@/assets/img/portfolio/logo_10.png";
import logo11 from "@/assets/img/portfolio/logo_11.png";
import logo12 from "@/assets/img/portfolio/logo_12.png";
import logo13 from "@/assets/img/portfolio/logo_13.png";
import logo14 from "@/assets/img/portfolio/logo_14.png";
import logo15 from "@/assets/img/portfolio/logo_15.png";
import logo16 from "@/assets/img/portfolio/logo_16.png";
import logo17 from "@/assets/img/portfolio/logo_17.png";
import logo18 from "@/assets/img/portfolio/logo_18.png";

export const navList = [
  {
    value: 1,
    name: "Fund I",
  },
  {
    value: 2,
    name: "Fund II",
  },
  {
    value: 3,
    name: "Project Fund",
  },
];

export const fundData: PortItemData[] = [
  {
    id: 1,
    logo: logo01,
    partner: "AI Software",
    year: 2018,
    type: 1,
    blurb:
      "The Attention Factory: Leading a Content Revolution with Powerful Algorithms",
    dataDetail: {
      founder: "Yiming Zhang",
      milestone: "Founded 2012 | 1.9 billion MAU across 150 countries by 2021",
      website: "bytedance.com/en/",
      url: "https://www.bytedance.com/en/",
    },
  },
  {
    id: 2,
    logo: logo02,
    partner: "AI Hardware",
    year: 2018,
    type: 1,
    blurb: "Made-for-Enthusiasts” Quality Tech, Accessible to Everyone",
    dataDetail: {
      founder: "Lei Jun",
      milestone:
        "Founded 2010 | IPO 2018 (OTCMKTS: XIACY) | Fortune Global 500 by 2019",
      website: "mi.com",
      url: "https://www.mi.com/us/",
    },
  },
  {
    id: 3,
    logo: logo03,
    partner: "AI Software",
    year: 2018,
    type: 1,
    blurb: "Secure and Intelligent Cloud Solutions",
    dataDetail: {
      founder: "Lei Jun",
      milestone: "Founded 2012 | IPO 2020 (NASDAQ: KC) & 2022 (3896.HK)",
      website: "en.ksyun.com",
      url: "https://en.ksyun.com/",
    },
  },
  {
    id: 4,
    logo: logo04,
    partner: "AI Software",
    year: 2018,
    type: 1,
    blurb:
      "One of the Largest Lifestyle Platforms: Everyday Services via Super-App",
    dataDetail: {
      founder: "Xing Wang",
      milestone:
        "IPO in Hong Kong, 2018; currently the largest food delivery app globally by revenue and usage",
      website: "Meituan.com",
      url: "https://www.meituan.com/en-US/about-us",
    },
  },
  {
    id: 5,
    logo: logo05,
    partner: "AI Software",
    year: 2020,
    type: 2,
    blurb: "Most Advanced Distributed SQL Database for Modern Applications",
    dataDetail: {
      founder: "Ed Huang, Max Liu, Dylan Cui",
      milestone: "Founded 2015 | TiDB adopted by 3,000+ companies by 2022",
      website: "pingcap.com",
      url: "https://cn.pingcap.com/",
    },
  },
  {
    id: 6,
    logo: logo06,
    partner: "AI Software",
    year: 2021,
    type: 2,
    blurb: "AI-Driven IT Operations Management and Monitoring",
    dataDetail: {
      founder: "Andy (Jin) Yin",
      milestone: "Founded 2018 | 1,000+ clients by 2023",
      website: "cloudwise.ai",
      url: "https://www.cloudwise.ai/",
    },
  },
  {
    id: 7,
    logo: logo07,
    partner: "AI Software",
    year: 2023,
    type: 2,
    blurb: "Empowering Creativity Worldwide with Simple and Powerful AI Tools",
    dataDetail: {
      founder: "Xinhong Wu",
      milestone: "Founded 2019 | 42M+ MAU and 2M+ paying customers by 2024",
      website: "Pixocial.com",
      url: "https://pixocial.com/",
    },
  },
  {
    id: 8,
    logo: logo08,
    partner: "AI Software",
    year: "2023",
    type: 2,
    blurb: "AI-Powered Personal Life Assistant",
    dataDetail: {
      founder: "Hua Mao",
      milestone: "Founded 2023",
      website: "Platox.ai",
      url: "https://platox.ai/",
    },
  },
  {
    id: 9,
    logo: logo09,
    partner: "AI Software",
    year: 2024,
    type: 2,
    blurb:
      "Asia's Largest Overseas Video Analytics Platform for Content E-commerce",
    dataDetail: {
      founder: "Eric Shi",
      milestone: "Founded 2022",
      website: "fastmoss.com",
      url: "https://www.fastmoss.com/",
    },
  },
  {
    id: 10,
    logo: logo10,
    partner: "AI Hardware",
    year: "2022",
    type: 2,
    blurb:
      "Disruptive In-Memory Computing (IMC) Technology for Edge Applications",
    dataDetail: {
      founder: "Dr. Glenn Ge, Dr. Miao Hu",
      milestone: "Founded 2018",
      website: "tetramem.com",
      url: "https://www.tetramem.com/",
    },
  },
  {
    id: 11,
    logo: logo11,
    partner: "AI Hardware",
    year: 2019,
    type: 2,
    blurb: "AI Chipmaker for Autonomous Driving Systems",
    dataDetail: {
      founder: "Johnson Shan, Wilson Liu",
      milestone: "Founded 2016 | IPO 2024 (HKG: 2533)",
      website: "bst.ai",
      url: "https://www.bst.ai",
    },
  },
  {
    id: 12,
    logo: logo12,
    partner: "AI Hardware",
    year: 2021,
    type: 2,
    blurb: "AI-First, Comprehensive Autonomous Driving Solutions",
    dataDetail: {
      founder: "Xu Lei, Justin Song",
      milestone: "Founded 2016 | $110M Series B in 2023",
      website: "nullmax.ai",
      url: "https://www.nullmax.ai/",
    },
  },
  {
    id: 13,
    logo: logo13,
    partner: "AI Hardware",
    year: 2020,
    type: 2,
    blurb: "Battery-As-A-Service for the Growing EV Network",
    dataDetail: {
      founder: "",
      milestone:
        "Founded 2020 | 10+ GWh of battery assets under management by 2024",
      website: "wnpower.cn",
      url: "http://www.wnpower.cn/",
    },
  },
  {
    id: 14,
    logo: logo14,
    partner: "AI Hardware",
    year: 2022,
    type: 2,
    blurb: "Iconic Sports Car Spirit, Electrified for the Future",
    dataDetail: {
      founder: "Qingfeng Feng",
      milestone: "Founded 2016 | IPO 2024 (Nasdaq: LOT)",
      website: "lotuscars.com",
      url: "https://www.lotuscars.com",
    },
  },
  {
    id: 15,
    logo: logo15,
    partner: "AI BioTech",
    year: 2021,
    type: 2,
    blurb: "AI-Powered Biotech Innovator for Efficient Drug Development",
    dataDetail: {
      founder: "Xu Yingqi",
      milestone: "Founded 2019 | Launched multiple AI platforms by 2024",
      website: "greatbay-bio.com",
      url: "https://www.greatbay-bio.com/",
    },
  },
  {
    id: 16,
    logo: logo16,
    partner: "AI Software",
    year: 2021,
    type: 2,
    blurb: "Leading Online Mental Health and Counseling Platform in China",
    dataDetail: {
      founder: "Xu Yingqi",
      milestone:
        "Founded 2015 | 40,000+ certified counselors and 30+ million users by 2024",
      website: "ydl.com",
      url: "https://www.ydl.com/",
    },
  },
  // {
  //   id: 17,
  //   logo: logo17,
  //   partner: "AI Hardware",
  //   year: 2017,
  //   type: 3,
  //   blurb: "Revolutionizing Mobility with Intelligent Electric Vehicles",
  //   dataDetail: {
  //     founder: "William Li",
  //     milestone: "Founded 2014 | IPO 2018 (NYSE: NIO)",
  //     website: "nio.com",
  //     url: "https://www.nio.cn/",
  //   },
  // },
  {
    id: 18,
    logo: logo18,
    partner: "AI Software",
    year: 2024,
    type: 3,
    blurb:
      "Open-Source, Lightweight, and Frontier LLMs for Devs and Enterprises",
    dataDetail: {
      founder: "Arthur Mensch. Guillaume Lample, Timothée Lacroix",
      milestone:
        "Founded May 2023 | Mistral 7B in Sep 2023 | Mixtral 8x7B in Dec 2023 | Mistral Large in Feb 2024",
      website: "mistral.ai",
      url: "https://mistral.ai/",
    },
  },
];
